export default {
    outdoorsCampaigns: [],
    outdoorsCampaignsLoading: false,
    outdoorsCampaignLocalizations: [],
    outdoorsCampaignLocalizationsLoading: false,
    outdoorsCampaignLocalizationScreens: [],
    productTemplates: [],
    campaign: {},
    customers: [],
    filters: {
        localization__street: null,
        inCampaign: true,
        campaign_id: null
    },
    cancelToken: null,
    isCampaignCreated: false
}
